import { render } from "./index.vue?vue&type=template&id=3e4acbbb"
const script = {}

import exportComponent from "/Users/gejiayang/Desktop/chunlin-overseas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__